import React, { useEffect, useRef, useState } from 'react';
import { Card, Typography } from 'antd';
import { config } from '../../config';

const PREVIEW_MESSAGE_TYPE = 'dwf-campaign-preview';
const DEBOUNCE_MS = 300;

/** The preview page reads its first content from the URL hash, as base64url of the JSON. */
const toBase64Url = (value) => {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = '';
    bytes.forEach((b) => { binary += String.fromCharCode(b); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

/**
 * The web client's /m/campaign-preview page drawn in an iframe: it draws the
 * same RichDialogContent the apps draw, so what the admin sees is what ships.
 * The hash seeds the first paint; later edits arrive by postMessage.
 */
export function CampaignPreview({ content, height = 640 }) {
    const iframeRef = useRef(null);
    const latestContent = useRef(content);
    const [initialSrc] = useState(() => `${config().clientBaseUrl}/m/campaign-preview#${toBase64Url(content)}`);

    const post = (value) => {
        iframeRef.current?.contentWindow?.postMessage({ type: PREVIEW_MESSAGE_TYPE, content: value }, '*');
    };

    useEffect(() => {
        latestContent.current = content;
        const timer = setTimeout(() => post(content), DEBOUNCE_MS);
        return () => clearTimeout(timer);
    }, [content]);

    return (
        <Card
            size="small"
            title="Live preview"
            extra={<Typography.Text type="secondary">{content.format === 'sheet' ? 'Bottom sheet' : 'Dialog'} · {content.theme} theme</Typography.Text>}
            styles={{ body: { padding: 0, background: '#141414', borderRadius: '0 0 8px 8px', overflow: 'hidden' } }}
        >
            <iframe
                ref={iframeRef}
                title="Campaign preview"
                src={initialSrc}
                onLoad={() => post(latestContent.current)}
                style={{ width: '100%', height, border: 'none', display: 'block', background: '#141414' }}
            />
        </Card>
    );
}
